import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';

import { fuseConfig } from 'app/fuse-config';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';
import { SampleModule } from 'app/main/sample/sample.module';
import { DeleteComponentComponent } from './delete-component/delete-component.component';
import { WhatsAppQRComponent } from './whats-app-qr/whats-app-qr.component';

const appRoutes: Routes = [
    {
        path: '',
        loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
    }, {
        path: 'signup',
        loadChildren: () => import('./register/register.module').then(m => m.RegisterModule)
    }, {
        path: 'chat',
        loadChildren: () => import('./messages/messages.module').then(m => m.MessagesModule)
    }, {
        path: 'users',
        loadChildren: () => import('./users/users.module').then(m => m.UsersModule)
    }, {
        path: 'register',
        loadChildren: () => import('./user-form/user-form.module').then(m => m.UserFormModule)
    }, {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
    }, {
        path: 'businesses',
        loadChildren: () => import('./businesses/businesses.module').then(m => m.BusinessesModule)
    }, {
        path: 'industries',
        loadChildren: () => import('./industries/industries.module').then(m => m.IndustriesModule)
    }, {
        path: 'chapters',
        loadChildren: () => import('./chapters/chapters.module').then(m => m.ChaptersModule)
    }, {
        path: 'groups',
        loadChildren: () => import('./groups/groups.module').then(m => m.GroupsModule)
    }, {
        path: 'password',
        loadChildren: () => import('./change-password/change-password.module').then(m => m.ChangePasswordModule)
    }, {
        path: 'analytics',
        loadChildren: () => import('./analytics/analytics.module').then(m => m.AnalyticsModule)
    }, {
        path: 'qr',
        component: WhatsAppQRComponent,
    }
];

@NgModule({
    declarations: [
        AppComponent,
        DeleteComponentComponent,
        WhatsAppQRComponent,

    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes, { useHash: false }),

        TranslateModule.forRoot(),

        // Material moment date module
        MatMomentDateModule,

        // Material
        MatButtonModule,
        MatIconModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,
        MatDialogModule,
        MatCheckboxModule,
        // App modules
        LayoutModule,
        SampleModule
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}
